import { render, staticRenderFns } from "./DoctorListModal.vue?vue&type=template&id=573ac87a&scoped=true&"
import script from "./DoctorListModal.vue?vue&type=script&lang=js&"
export * from "./DoctorListModal.vue?vue&type=script&lang=js&"
import style0 from "./DoctorListModal.vue?vue&type=style&index=0&id=573ac87a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573ac87a",
  null
  
)

export default component.exports